<template>
    <v-dialog
        width="500"
        persistent
        scrollable
        v-model="display">
        <v-card>
            <v-toolbar dense flat color="primary" dark>
                <v-toolbar-title>Exchange Rates</v-toolbar-title>
                <v-spacer></v-spacer>
                <p-icon-btn
                    icon="mdi-undo" 
                    tooltip="Reset Custom Rates"
                    @click="resetCustomRates"></p-icon-btn>
            </v-toolbar>
            <v-card-text>
                <v-simple-table>
                    <thead>
                        <tr>
                            <th>Currency</th>
                            <th>Index Rate</th>
                            <th>Custom Rate</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="rate in data" :key="rate.id">
                            <td>{{rate.abbreviation}}</td>
                            <td>{{rate.rate}}</td>

                            <td>
                                <v-text-field
                                    :disabled="rate.rate === 1"
                                    :color="getBackgroundColor(rate)"
                                    dense
                                    outlined
                                    hide-details
                                    v-model="rate.customRate"
                                    :append-icon="getAppendIcon(rate)"
                                    :suffix="getDiff(rate)">
                                </v-text-field>
                            </td>
                        </tr>
                    </tbody>
                </v-simple-table>
            </v-card-text>
            <v-card-actions>
                <v-btn @click="submit" text>Ok</v-btn>
                <v-btn @click="display = false" text>Close</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { cloneDeep } from 'lodash';
import { formatNumber } from 'accounting';

import PIconBtn from '../common/PIconBtn';

export default {
    name: "ExchangeRateIndex",
    components: {
        PIconBtn
    },
    data() {
        return {
            data: []
        }
    },
    props: {
        value: Boolean,
        exchangeRates: Array
    },
    computed: {
        display: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit("input", val);
            }
        }
    },
    methods: {
        formatNumber,
        resetCustomRates() {
            this.data.map(each => each.customRate = each.rate)
        },
        submit() {
            this.$emit('update:exchange-rates', cloneDeep(this.data));
            this.display = false;
        },
        getAppendIcon({customRate, rate}) {
            if(customRate == rate) return "";
            if(customRate > rate) return "mdi-arrow-up-bold";
            if(customRate < rate) return "mdi-arrow-down-bold"; 
        },
        getBackgroundColor({customRate, rate}) {
            if(customRate > rate) return "success";
            if(customRate < rate) return "error"; 
        },
        getDiff({customRate, rate}) {
            let diff = rate - customRate;
            if(diff == 0) return null;
            else return formatNumber(Math.abs(diff), 3)
        }
    },
    created() {
        this.data = cloneDeep(this.exchangeRates);
    }
}
</script>